import { EARLY_LAUNCH_COUNTRIES } from '@/settings/Country';

export default {
	computed: {
		earlyLaunch() {
			return EARLY_LAUNCH_COUNTRIES.includes(this.country);
		},
	},
};
